<template>
	<!-- 弹窗 -->
	<el-dialog :title="mode" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
		
		<!-- 打分 -->
		<div class="dialogList" v-if="mode === '考核项目打分'">
			<p class="normalList_p">项目类型：优秀项目经理</p>
			<p class="normalList_p">项目名称：2021年度第二批北京市优秀项目经理</p>
			<p class="normalList_p">申报人：张志兴</p>
			<p class="normalList_p">提交时间：2022.1.10 08:00:00</p>
			<p class="specilList_p">请根据当前申请的基本素质（总分30分）、经营指标（总分30分）、企业管理（总分40分）、
			市场信用（总分20分、优良--不良）进行评分。</p>
			<labelInput spanTitle="初审分" spanWidth="48px" componentWidth="430px" >
			</labelInput>
		</div>
		
		<!-- 同意推荐 -->
		<div class="recommendTip" v-if="mode === '同意推荐'">
			<p>确定同意推荐？一旦同意，无法撤销</p>
		</div>
		
		<!--  -->
		<span slot="footer" class="dialog-footer" v-if="mode === '考核项目打分'">
			<el-button @click="dialogVisible = false">返 回</el-button>
			<el-button type="primary" @click="dialogVisible = false">确认上传</el-button>
		</span>
		
		<span slot="footer" class="dialog-footer" style="justify-content: center;display: flex;" v-if="mode === '同意推荐'">
			<el-button @click="chooseDetail(false)">取 消</el-button>
			<el-button type="primary" @click="chooseDetail(true)">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		setRecommend
	} from '../../../api/moudles/management.js'
	import labelInput from "../../../components/table/labelInput.vue"
	export default {
		data() {
			return {
				dialogVisible: false,
				mode:'score'
			}
		},
		components: {
			labelInput,
		},
		
		methods: {
			// 接口三：推荐
			async setRecommend(){
				await setRecommend({
					data:{
						ids:this.ids
					},
					success:res=>{
						if(res.code === 200){
							this.$message({
								message: res.msg,
								type: 'success'
							});
							const params = {
								type:true,
								res
							}
							this.$emit('chooseDetail',params)
						}else{
							this.$message.error(res.msg)
							const params = {
								type:false,
								res
							}
							this.$emit('chooseDetail',params)
						}
						this.dialogVisible = false
					}
				})
			},
			chooseDetail(type){
				console.log(type)
				if(type){
					this.setRecommend()
				}else{
					this.dialogVisible = false
				}
			},
			showAdd(type,params) {
				this.dialogVisible = true
				this.mode = type
				this.ids = params
			},
			handleClose() {
				this.dialogVisible = false
			},
			
		}
	}
</script>

<style scoped="scoped">
	.el-dialog__header {
		height: 100px;
		line-height: 100px;
	}

	>>>.el-dialog__body {
		padding: 10px 20px;
	}
	>>>.el-dialog{
		border-radius: 6px;
	}

	/* 评分弹窗 */
	.dialogList{
		display: flex;
		flex-flow: column;
		align-items: flex-start;
	}
	.normalList_p{
		height: 25px;
		line-height: 25px;
		padding-left: 3px;
	}
	.specilList_p{
		margin: 10px 0;
		line-height: 25px;
		text-indent: 2em;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FA6400;
	}
	.recommendTip{
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		color: #333333;
	}
</style>
